import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { RiTableLine, RiKey2Fill, RiLinkM } from '@remixicon/react';
import styles from './table-node.module.css';

interface ColumnData {
  name: string;
  type: string;
  isPK: boolean;
  isFK: boolean;
}

export interface TableNodeData {
  tableName: string;
  width?: number;
  columns: ColumnData[];
  [key: string]: unknown;
}

const ROW_HEIGHT = 24;
const HEADER_HEIGHT = 32;

export const TableNode = memo(({ data }: NodeProps) => {
  const { tableName, columns, width } = data as unknown as TableNodeData;

  return (
    <div
      className={styles.tableContainer}
      style={{ width: width ? `${width}px` : undefined }}
    >
      <Handle id="top" type="source" position={Position.Top} className={styles.handle} />
      <Handle id="top" type="target" position={Position.Top} className={styles.handle} />
      <Handle id="bottom" type="source" position={Position.Bottom} className={styles.handle} />
      <Handle id="bottom" type="target" position={Position.Bottom} className={styles.handle} />
      <Handle id="left" type="source" position={Position.Left} className={styles.handle} />
      <Handle id="left" type="target" position={Position.Left} className={styles.handle} />
      <Handle id="right" type="source" position={Position.Right} className={styles.handle} />
      <Handle id="right" type="target" position={Position.Right} className={styles.handle} />

      {/* Header */}
      <div className={styles.header}>
        <RiTableLine size={12} className={styles.headerIcon} />
        <span className={styles.headerName}>
          {tableName}
        </span>
      </div>

      {/* Columns */}
      <div className={styles.columnsWrap}>
        {columns.map((col) => (
          <div
            key={col.name}
            className={styles.columnRow}
          >
            {/* Badge icon */}
            <span className={styles.badgeCell}>
              {col.isPK && <RiKey2Fill size={10} className={styles.pkIcon} />}
              {!col.isPK && col.isFK && <RiLinkM size={10} className={styles.fkIcon} />}
            </span>

            {/* Column name */}
            <span className={styles.colName}>
              {col.name}
            </span>

            {/* Type pill */}
            <span className={styles.typePill}>
              {col.type}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
});

TableNode.displayName = 'TableNode';

export { ROW_HEIGHT, HEADER_HEIGHT };
